import React from "react";
import "./index.css";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import { connect } from "react-redux";

function Gifts({ order, language }) {
  if (
    !order.gift_recipient_name &&
    !order.gift_recipient_number &&
    !order.gift_message
  )
    return <></>;
  return (
    <div
      className="border w-100 row m-0 mt-4"
      style={{ backgroundColor: "white", minHeight: 70 }}
    >
      <div className="col-2" style={{ position: "relative" }}>
        <CardGiftcardIcon
          className="center-x-y"
          style={{ fontSize: 32, color: "#999" }}
        />
      </div>
      <div
        className={"col-10 py-3 ".concat(
          language == "english" ? "text-left" : "text-right"
        )}
      >
        <p className="mb-2 bold">
          {language == "english" ? "Gift details:" : "تفاصيل الهدية:"}
        </p>

        {order.gift_recipient_name ? (
          <p className="m-0">
            <span className="bold">
              {language == "english" ? "Name" : "الاسم"}:{" "}
            </span>{" "}
            {order.gift_recipient_name}
          </p>
        ) : null}
        {order.gift_recipient_number ? (
          <p className="m-0">
            <span className="bold">
              {language == "english" ? "Number" : "الرقم"}:{" "}
            </span>{" "}
            {order.gift_recipient_number}
          </p>
        ) : null}
        {order.gift_message ? (
          <p className="m-0">
            <span className="bold">
              {language == "english" ? "Message" : "الرسالة"}:{" "}
            </span>{" "}
            {order.gift_message}
          </p>
        ) : null}
        {order.gift_link ? (
          <p className="m-0">
            <span className="bold">
              {language == "english" ? "Gift link" : "رابط الهدية"}:{" "}
            </span>{" "}
            {order.gift_link.startsWith("http") ? (
              <a href={order.gift_link} target="_blank">
                {order.gift_link}
              </a>
            ) : (
              order.gift_link
            )}
          </p>
        ) : null}
        {order.send_gift_anonymously ? (
          <p className="m-0">
            <span className="bold">
              {language === "english"
                ? "Gift will be sent anonymously"
                : "الهدية سترسل بشكل مجهول"}{" "}
            </span>{" "}
          </p>
        ) : null}
        {order.gift_wrapping ? (
          <p className="m-0">
            <span className="bold">
              {language === "english"
                ? "Gift wrapping added"
                : "تمت إضافة تغليف الهدايا"}{" "}
            </span>{" "}
          </p>
        ) : null}
        {order.unknown_gift_recipient_location ? (
          <p className="m-0">
            <span className="bold">
              {language === "english"
                ? "Receiver address is unknown"
                : "عنوان المستلم غير معروف"}{" "}
            </span>{" "}
          </p>
        ) : null}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(Gifts);
